// import React, { useState } from 'react';
// import styled from 'styled-components';
// import { useSelector, useDispatch } from 'react-redux';
// import { useEffect } from 'react';
// import { getUsers, deactivateUser, adminManageUserStatus, fetchAllContributions } from 'Features/api/api';
// import Spinner from 'SharedFns/SpinnerElement';

// import Modal from '../../SharedFns/Modal';
// import RemoveRoleForm from 'components/Users/RemoveUserRoles';
// import UserFinancialDocument from 'components/documents/UserFinancialSummary';
// import ExitForm from 'components/Users/ExitForm';  
// import { baseURL } from 'SharedFns/Functions';
// import UserClearanceForm from 'components/Users/ClearanceForm';
// import ExitFormModal from 'SharedFns/ExitFormModal';
// // Sample data for members

// const members = [
//   {
//     id: 1,
//     firstName: 'John',
//     lastName: 'Doe',
//     regNumber: '12345',
//     title: 'Manager',
//     profilePic: 'https://via.placeholder.com/50'
//   },
//   {
//     id: 2,
//     firstName: 'Jane',
//     lastName: 'Smith',
//     regNumber: '67890',
//     title: 'Developer',
//     profilePic: 'https://via.placeholder.com/50'
//   }
//   // Add more members as needed
// ];



// const LoanSummary = () => {
//     const dispatch=useDispatch()
//     useEffect( ()=>{
//         dispatch(getUsers())
//         dispatch(fetchAllContributions())

//       }, [dispatch])
//     const [isModalOpen, setIsModalOpen]=useState(false)
//     const [isRemoveModalOpen, setIsRemoveModalOpen]=useState(false)
//     const [isExitModalOpen, setIsExitModalOpen]=useState(false)
//       const getFullPhotoUrl = (photo) => {
//           const baseUrl =baseURL // Adjust base URL as necessary
//         return baseUrl + photo;
//       };
//     const users=useSelector(state=> state.getUsers?.users?.users)
//     const isLoading=useSelector(state => state.getUsers?.loading || state.getAllContributions?.loading||state.getbalanceSheet?.loading||state.exitMember?.loading||state.clearMember?.loading)
//     const contributions=useSelector(state=>state.getAllContributions?.allContributions)
//     const userCount=useSelector(state => state.activeUsersCount?.users?.active_users_count)
//   const balanceSheetData = useSelector(state => state.getbalanceSheet?.balanceSheetData.balance_sheet??[])
//   const users_shared_interest_data=useSelector(state => state.getbalanceSheet?.balanceSheetData?.users_shared_interest_data??[])
//     const is_active=useSelector(state=>state.getUsers?.users?.users.is_active )
//     const [selectedUserId, setSelectedUserId]=useState(null) 
//     const [selectedMember, setSelectedMember] = useState(null);
//     const[selectedClearMember, setSelectedClearMember]=useState(null)
//     const[isClearanceModalOpen,  setIsClearanceModalOpen] =useState(false)
//     // const activeUsers = users?.filter(user => user.is_active);
   
//     const statusCodeToName={
//       'pending_approval':'Pending Approval',
//       'active':'Active',
//       'dormant':'Dormant',
//       'cleared':'Cleared',
  
//      }
   
//     const handleDeactivate=(user_id)=>{
//       dispatch( deactivateUser({user_id}))

//     }
//     const handleActivate=(user_id)=>{
//       dispatch( adminManageUserStatus({user_id}))

//     }
//    const handleAssignRole=(userId)=>{
    
//     setIsModalOpen(true)
//     setSelectedUserId(userId)
//     console.log('The initial selected ID',userId)
//     console.log('The set selected ID',selectedUserId)
//       // dispatch( adminActivateUser({user_id}))

//     }
//     const handleClearMember = (member) => {
//       setSelectedMember(member);
//       setIsClearanceModalOpen(true);
//     };
//     const handleExitClick = (member) => {
//       setSelectedMember(member);
//       setIsExitModalOpen(true);
//     };
   
//     const handleSummary=(userId)=>{
     
//       setIsModalOpen(true)
//       setSelectedUserId(userId)
//         // dispatch( adminActivateUser({user_id}))
  
//       }
//       const getUserContributions = (username) => {
//         return contributions?.filter(contribution => contribution.user === username) || [];
//       };
      
//       const getTotalContributionsForMember = (member) => {
//         const userContributions = getUserContributions(member.username);
//         return userContributions.reduce((acc, contribution) => acc + contribution.total_contributions, 0);
//       };
    
//     const nonClearedLoans = (member) => {
//       return member?.loans?.filter(loan => loan.status === 'active' || loan.status === 'default' || loan.status === 'written_off' );
//     };

//     const getTotalNonclearedLoans=(member)=>{
//       const unClearedLoans=nonClearedLoans(member);

//       return unClearedLoans?.reduce((acc, loan) => acc + loan.current_balance, 0)
//     };
    
//     const userContributions = selectedUserId?contributions?.filter(contribution => contribution.user === selectedUserId.username) : [];
//     const totalUserContributions = userContributions?.reduce((acc, contribution) => acc + contribution.total_contributions, 0);


//   return (
    
//     <MemberListContainer>
//         <div>
//     { isLoading && <Spinner/>}
//     </div>
//    <ExitFormModal isOpen={isClearanceModalOpen} onClose={()=>setIsClearanceModalOpen(false)}>
//     <UserClearanceForm  user={selectedUserId} users_shared_interest_data={users_shared_interest_data} setIsClearanceModalOpen={setIsClearanceModalOpen} selectedMember ={selectedMember} totalUserContributions={totalUserContributions} balanceSheetData={balanceSheetData} userCount={userCount}/>

//    </ExitFormModal>
//     <ExitFormModal  style={{ zIndex: 10000 }}  isOpen={isExitModalOpen} onClose={() => setIsExitModalOpen(false)}  >
//         {<ExitForm user={selectedUserId}  users_shared_interest_data={users_shared_interest_data} setIsExitModalOpen ={setIsExitModalOpen} selectedMember ={selectedMember} totalUserContributions={totalUserContributions} balanceSheetData={balanceSheetData} userCount={userCount}/> }
//       </ExitFormModal>
//     <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title='View Summary'>
//                 {<UserFinancialDocument isLoading={isLoading}  users_shared_interest_data={users_shared_interest_data} totalUserContributions={totalUserContributions} setIsModalOpen={setIsModalOpen} user={selectedUserId}  balanceSheetData={balanceSheetData} userCount={userCount}  />}
//             </Modal> 
//             <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title='Remove Role'>
//                 {<RemoveRoleForm setIsRemoveModalOpen={setIsRemoveModalOpen} userId={selectedUserId} />}
//             </Modal>           
//       {users?.map(member => (
//         <MemberCard  key={member.id} onClick={() => handleSummary(member)}>
         
//            {/* <ProfilePic  src="http://localhost:8000/media/user_images/mylinkedin_photo-min.jpg/> */}
//           <ProfilePic src={getFullPhotoUrl( member.photo)} alt={`${member.first_name}`} />
//           {/* <ProfilePic src={"http://localhost:8000/media/user_images/mylinkedin_photo-min.jpg"} alt={`${member.first_name}`} /> */}
//           <MemberInfo>
//             <MemberName>{`${member.first_name} ${member.last_name}`}</MemberName>
//             <MemberDetails>ID: {member.id}</MemberDetails>
//             <MemberDetails>Reg Number: {member.reg_number}</MemberDetails>
//             <MemberDetails>Title: {member.user_groups[0]?member.user_groups[0]:'Member'}</MemberDetails>
//             <StatusDetail status={member.status}>Membership Status: {statusCodeToName[member.status]}</StatusDetail>
//             {/* <SignUpBtn onClick={()=>handleSummary(member.username)}> On Exit </SignUpBtn> */}
//             <LoanDetails>
//               <p> Loan Details:</p>
              
            
//               {member.loans && member.loans.length > 0 ? (
//                 member.loans.map((loan, index) => (
//                   <LoanItem key={index}>
//                     <LoanDetail>Principal: {loan.amount}</LoanDetail>
//                     <LoanDetail>Start Date: {loan.start_date}</LoanDetail>
//                     <LoanDetail>Expiry Date: {loan.expiry_date}</LoanDetail>
//                     <StatusDetail status={loan.status}>Status: {loan.status}</StatusDetail>
//                     <LoanDetail>Remaining Balance: {loan.current_balance}</LoanDetail>
//                   </LoanItem>
//                 ))
//               ) : (
//                 <LoanDetail>No loans available</LoanDetail>
//               )}
//             </LoanDetails>
//             <ContributionDetails>
//               <p>Contribution Update:</p>
//                             {getUserContributions(member.username)?.length > 0 ? (
//                                 getUserContributions(member.username).map((contribution, index) => (
//                                     <ContributionItem key={index}>
//                                         <ContributionDetail>Amount: {contribution.latest_contribution.amount}</ContributionDetail>
//                                         <ContributionDetail>Month: {contribution.latest_contribution.month}</ContributionDetail>
//                                         <ContributionDetail>Total Contributions: {contribution.total_contributions}</ContributionDetail>
//                                     </ContributionItem>
//                                 ))
//                             ) : (
//                                 <ContributionDetail>No contributions available</ContributionDetail>
//                             )}
//                         </ContributionDetails>
//                         {nonClearedLoans(member).length > 0 ? (
//         <SignUpBtn 
//           onClick={() => handleExitClick(member)} 
//           // disabled={getTotalContributionsForMember(member)< getTotalNonclearedLoans(member)}
//           style={{ 
//             backgroundColor: getTotalContributionsForMember(member)< getTotalNonclearedLoans(member)? "grey" : "#E2725B",
//             // cursor: getTotalContributionsForMember(member)< getTotalNonclearedLoans(member) ? "not-allowed" : "pointer"
//             cursor: "pointer"
//           }}
//         >
//           Exit Member
//         </SignUpBtn>
//       ) : (
//         <SignUpBtn 
//           onClick={() => handleClearMember(member)}
//           disabled={getTotalContributionsForMember(member)<=0}
//           style={{ 
//             backgroundColor: getTotalContributionsForMember(member)<=0 ? "grey" : "blue",
//             cursor: getTotalContributionsForMember(member)<=0 ? "not-allowed" : "pointer"
//           }}
//         >
//           {member.has_cleared?"Member Cleared" :"Clear this Member"}
//         </SignUpBtn>
//       )}
    
  

//           </MemberInfo>
//           {/* {member.is_active ?
//   <SignUpBtn onClick={() => handleDeactivate(member.id)}> Deactivate User</SignUpBtn> : <SignUpBtn onClick={() => handleActivate(member.id)}> Activate User</SignUpBtn>
// }
//           {member.user_groups[0]?<SignUpBtn onClick={()=>handleRemoverole(member.id)}>Remove Role</SignUpBtn>:<SignUpBtn onClick={()=> handleAssignRole(member.id)}>Assign Role</SignUpBtn>}
//            */}
//         </MemberCard>
//       ))}
//     </MemberListContainer>
//   );
// };
// // Styled-components
// const MemberListContainer = styled.div`
// width:100%;
// height:80%;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content:flex-start;
//   overflow:scroll;
// `;

// const MemberCard = styled.div`
//   display: flex;
//   align-items: flex-start;
//   justify-content:flex-start;
//   background-color: #f8f9fa;
//   padding: 10px;
//   margin: 10px 0;
//   border-radius: 8px;
//   width: 80%;
//   cursor: pointer;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
// `;

// const ProfilePic = styled.img`
//   border-radius: 50%;
//   width: 50px;
//   height: 50px;
//   margin-right: 20px;
// `;

// const MemberInfo = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// const MemberName = styled.div`
//   font-size: 18px;
//   font-weight: bold;
// `;

// const MemberDetails = styled.div`
//   font-size: 14px;
//   color: #666;
// `;
// const LoanDetails = styled.div`
//   margin-top: 10px;
// `;

// const LoanItem = styled.div`
//   margin-bottom: 5px;
//   padding: 5px;
//   background-color: #eaeaea;
//   border-radius: 5px;
// `;

// const LoanDetail = styled.div`
//   font-size: 12px;
//   color: #333;
// `;
// const StatusDetail = styled.div`
//   font-size: 12px;
//   color: ${({ status }) => {
//     switch (status) {
//       case 'active':
//         return 'green';
//       case 'cleared':
//         return 'blue';
//       case 'dormant':
//         return 'red';
//       case 'pending_approval':
//         return  'orange'
//       case 'default':
//         return 'red'  
//       default: 
//         return '#333';
//     }
//   }};
// `;
// const ContributionDetails = styled.div`
//   margin-top: 10px;
// `;

// const ContributionItem = styled.div`
//   margin-bottom: 5px;
//   padding: 5px;
//   background-color: #eaeaea;
//   border-radius: 5px;
// `;

// const ContributionDetail = styled.div`
//   font-size: 12px;
//   color: #333;
//   `
// const SignUpBtn = styled.button`
// margin-left:20px;
// display:flex;
// justify-content:flex-start;
// cursor:pointer;
// padding: 10px 30px;
// border-radius:10px;
// background-color:#E2725B;
// color:#f9f9f9;
// border:none;
// border-color:#E2725B;
// @media (max-width: 768px) {
//     font-size:10px;
//     padding: 5px 15px;
// }
// `
// ;
// export default LoanSummary;

// LoanSummary.jsx
// LoanSummary.jsx
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import {
  getUsers,
  fetchAllContributions,
  fetchMemberBadDebts,
  fetchBalanceSheet
} from 'Features/api/api';

import Spinner from 'SharedFns/SpinnerElement';
import Modal from 'SharedFns/Modal';
import UserFinancialDocument from 'components/documents/UserFinancialSummary';
import ExitForm from 'components/Users/ExitForm';
import UserClearanceForm from 'components/Users/ClearanceForm';
import ExitFormModal from 'SharedFns/ExitFormModal';
import { baseURL } from 'SharedFns/Functions';
import BadDebtRecoveryForm from 'components/Users/BadDebtRecoveryForm';


const LoanSummary = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsers());
    dispatch(fetchAllContributions());
    // dispatch(fetchBalanceSheet())
    dispatch(fetchMemberBadDebts())
  }, [dispatch]);

  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const [isClearanceModalOpen, setIsClearanceModalOpen] = useState(false);
  const [isRecoveryModalOpen, setIsRecoveryModalOpen] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);

  const users = useSelector((state) => state.getUsers?.users?.users);
  const isLoading = useSelector((state) =>
    state.getUsers?.loading ||
    state.getAllContributions?.loading ||
    state.getbalanceSheet?.loading ||
    state.exitMember?.loading ||
    state.clearMember?.loading
  );

  const contributions = useSelector((state) => state.getAllContributions?.allContributions);
  const userCount = useSelector((state) => state.activeUsersCount?.users?.active_users_count);
  const balanceSheetData = useSelector((state) => state.getbalanceSheet?.balanceSheetData.balance_sheet ?? []);
  const users_shared_interest_data = useSelector((state) => state.getbalanceSheet?.balanceSheetData?.users_shared_interest_data ?? []);

  const badDebtsAll = useSelector((state) => state.badDebt?.all || []);
 

  const getFullPhotoUrl = (photo) => `${baseURL}${photo || ''}`;

  const statusCodeToName = {
    pending_approval: 'Pending Approval',
    active: 'Active',
    dormant: 'Dormant',
    cleared: 'Cleared',
  };

  const handleClearMember = (member) => {
    setSelectedMember(member);
    setSelectedUser(member);
    setIsClearanceModalOpen(true);
  };

  const handleExitClick = (member) => {
    setSelectedMember(member);
    setSelectedUser(member);
    setIsExitModalOpen(true);
  };

  const handleSummary = (member, e) => {
    e?.stopPropagation?.();
    setIsSummaryOpen(true);
    setSelectedUser(member);
  };

  const openRecovery = (member, e) => {
    e?.stopPropagation?.();
    setSelectedMember(member);
    setSelectedUser(member);
    dispatch(fetchMemberBadDebts({ member_id: member.id }));
    setIsRecoveryModalOpen(true);
  };

  const getUserContributions = (username) =>
    contributions?.filter((c) => c.user === username) || [];

  const getTotalContributionsForMember = (member) => {
    const rows = getUserContributions(member.username);
    return rows.reduce((acc, r) => acc + r.total_contributions, 0);
  };

  const nonClearedLoans = (member) =>
    member?.loans?.filter((loan) =>
      ['active', 'default', 'written_off'].includes(loan.status)
    ) || [];

  const getTotalNonclearedLoans = (member) =>
    nonClearedLoans(member)?.reduce((acc, loan) => acc + (Number(loan.current_balance) || 0), 0);

  const getLatestLoanStatus = (member) => {
    const loans = nonClearedLoans(member);
    if (loans.length === 0) return 'No Loan';
    return loans[0]?.status || 'Unknown';
  };

  const selectedUserContribs = selectedUser
    ? contributions?.filter((c) => c.user === selectedUser.username)
    : [];
  const totalUserContributions = selectedUserContribs?.reduce((acc, r) => acc + r.total_contributions, 0);
const getOutstandingBadDebt = (member) => {
  // filter debts belonging to this member
  const entry = badDebtsAll.filter((d) => d.member === member?.id);

  // console.log("Entry", entry);

  if (entry.length === 0) return 0;

  return entry.reduce((total, d) => total + Number(d.outstanding || 0), 0);
};



  const formatKES = (n) =>
    new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES', maximumFractionDigits: 2 }).format(Number(n || 0));

  return (
    <Wrapper>
      {isLoading && <Spinner />}

      {/* Summary Modal */}
      <Modal isOpen={isSummaryOpen} onClose={() => setIsSummaryOpen(false)} title="View Summary">
        {selectedUser && (
          <UserFinancialDocument
            isLoading={isLoading}
            users_shared_interest_data={users_shared_interest_data}
            totalUserContributions={totalUserContributions}
            setIsModalOpen={setIsSummaryOpen}
            user={selectedUser}
            balanceSheetData={balanceSheetData}
            userCount={userCount}
          />
        )}

        {/* Extra Loan & Contribution details inside the modal */}
        {selectedUser && (
          <DetailsWrapper>
            <DetailSection>
              <SectionTitle>Loans</SectionTitle>
              {selectedUser.loans && selectedUser.loans.length > 0 ? (
                selectedUser.loans.map((loan, index) => (
                  <DetailCard key={index}>
                    <DetailText>Principal: {formatKES(loan.amount)}</DetailText>
                    <DetailText>Start Date: {loan.start_date}</DetailText>
                    <DetailText>Expiry Date: {loan.expiry_date}</DetailText>
                    <StatusText status={loan.status}>Status: {loan.status}</StatusText>
                    <DetailText>Remaining Balance: {formatKES(loan.current_balance)}</DetailText>
                  </DetailCard>
                ))
              ) : (
                <DetailText>No loans available</DetailText>
              )}
            </DetailSection>

            <DetailSection>
              <SectionTitle>Contributions</SectionTitle>
              {getUserContributions(selectedUser.username)?.length > 0 ? (
                getUserContributions(selectedUser.username).map((contribution, index) => (
                  <DetailCard key={index}>
                    <DetailText>
                      Amount: {formatKES(contribution.latest_contribution.amount)}
                    </DetailText>
                    <DetailText>Month: {contribution.latest_contribution.month}</DetailText>
                    <DetailText>
                      Total Contributions: {formatKES(contribution.total_contributions)}
                    </DetailText>
                  </DetailCard>
                ))
              ) : (
                <DetailText>No contributions available</DetailText>
              )}
            </DetailSection>
          </DetailsWrapper>
        )}
      </Modal>

      {/* Clearance Modal */}
      <ExitFormModal isOpen={isClearanceModalOpen} onClose={() => setIsClearanceModalOpen(false)}>
        {selectedUser && selectedMember && (
          <ExitForm
            user={selectedUser}
            users_shared_interest_data={users_shared_interest_data}
            setIsExitModalOpen={setIsExitModalOpen}
            selectedMember={selectedMember}
            totalUserContributions={totalUserContributions}
            balanceSheetData={balanceSheetData}
            userCount={userCount}
          />
        )}
      </ExitFormModal>

      {/* Exit Modal */}
      <ExitFormModal style={{ zIndex: 10000 }} isOpen={isExitModalOpen} onClose={() => setIsExitModalOpen(false)}>
        {selectedUser && selectedMember && (
          <ExitForm
            user={selectedUser}
            users_shared_interest_data={users_shared_interest_data}
            setIsExitModalOpen={setIsExitModalOpen}
            selectedMember={selectedMember}
            totalUserContributions={totalUserContributions}
            balanceSheetData={balanceSheetData}
            userCount={userCount}
          />
        )}
      </ExitFormModal>

      {/* Bad Debt Recovery Modal */}
      <ExitFormModal isOpen={isRecoveryModalOpen} onClose={() => setIsRecoveryModalOpen(false)}>
        {selectedUser && (
          <BadDebtRecoveryForm
            member={selectedUser}
            onClose={() => setIsRecoveryModalOpen(false)}
            debts={badDebtsAll[selectedUser?.id]}
          />
        )}
      </ExitFormModal>

      {/* Member List */}
      <List>
        {users?.map((member) => {
       
          const loans = nonClearedLoans(member);
          const totalLoans = getTotalNonclearedLoans(member);
          const totalContribs = getTotalContributionsForMember(member);
          const badDebtOutstanding = getOutstandingBadDebt(member);
          const latestLoanStatus = getLatestLoanStatus(member);

          return (
            <Card key={member.id} onClick={(e) => handleSummary(member, e)}>
              <Left>
                <Avatar src={getFullPhotoUrl(member.photo)} alt={member.first_name} />
                <MainInfo>
                  <Name>{member.first_name} {member.last_name}</Name>
                  <Subtle>ID: {member.id} • Reg: {member.reg_number}</Subtle>
                  <Subtle>Role: {member.user_groups?.[0] || 'Member'}</Subtle>
                  <Badges>
                    <Status $variant={member.status}>
                      {statusCodeToName[member.status] || member.status}
                    </Status>
                    {badDebtOutstanding > 0 && (
                      <Pill>Bad Debt: {formatKES(badDebtOutstanding)}</Pill>
                    )}
                  </Badges>
                </MainInfo>
              </Left>

              <Right>
                <Stat>
                  <Label>Total Contributions</Label>
                  <Value>{formatKES(totalContribs)}</Value>
                </Stat>
                <Stat>
                  <Label>Loan Balance</Label>
                  <Value>{formatKES(totalLoans)}</Value>
                </Stat>
                <Stat>
                  <Label>Loan Status</Label>
                  <Status $variant={latestLoanStatus}> 
                     {statusCodeToName[latestLoanStatus] || latestLoanStatus}
                  </Status>
                </Stat>
                <Actions onClick={(e) => e.stopPropagation()}>
  <ActionButton onClick={(e) => handleSummary(member, e)}>Summary</ActionButton>

  {/* If member has outstanding bad debt → no Exit, only Recover */}
  {badDebtOutstanding > 0 ? (
    <ActionButton $variant="recover" onClick={(e) => openRecovery(member, e)}>
      Recover Bad Debt
    </ActionButton>
  ) : loans.length > 0 ? (
    // Member has loans but no bad debt → show Exit (always warning now)
    <ActionButton
      $variant="warning"
      onClick={(e) => handleExitClick(member, e)}
    >
      Exit
    </ActionButton>
  ) : (
    // No loans → show Clear button
    <ActionButton
      $variant={totalContribs > 0 ? 'primary' : 'disabled'}
      disabled={totalContribs === 0}
      onClick={(e) => handleClearMember(member, e)}
    >
      {member.has_cleared ? 'Cleared' : 'Clear'}
    </ActionButton>
  )}
</Actions>

              </Right>
            </Card>
          );
        })}
      </List>
    </Wrapper>
  );
};

export default LoanSummary;

/* =============== styled-components =============== */

const Wrapper = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 12px;
  padding: 8px 0;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 24px;
`;

const Card = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;
  background: #fff;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 2px 10px rgba(16,24,40,0.06);
  cursor: pointer;
  &:hover { box-shadow: 0 4px 16px rgba(16,24,40,0.08); }
`;

const Left = styled.div`
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 12px;
  align-items: start;
`;

const Right = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0,1fr));
  gap: 12px;
  align-items: center;
`;

const Avatar = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
`;

const MainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #101828;
`;

const Subtle = styled.div`
  font-size: 12px;
  color: #667085;
`;

const Badges = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Status = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  color: ${({ $variant }) => (
    $variant === 'active' ? '#027A48' :
    $variant === 'cleared' ? '#175CD3' :
    $variant === 'pending_approval' ? '#B54708' :
    $variant === 'dormant' ? '#B42318' :
     $variant === 'written_off'? 'gray' :
     $variant === 'default' ? '#B42318' :
     
    '#344054'
  )};
  background: ${({ $variant }) => (
    $variant === 'active' ? 'rgba(2,122,72,0.08)' :
    $variant === 'cleared' ? 'rgba(23,92,211,0.08)' :
    $variant === 'pending_approval' ? 'rgba(181,71,8,0.08)' :
    $variant === 'dormant' ? 'rgba(180,35,24,0.08)' :
    'rgba(52,64,84,0.06)'
  )};
`;

const Pill = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  color: #6941c6;
  background: rgba(105,65,198,0.08);
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Label = styled.div`
  font-size: 12px;
  color: #667085;
`;

const Value = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #101828;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  cursor: pointer;

  background: ${({ $variant }) => (
    $variant === 'primary' ? '#175CD3' :
    $variant === 'warning' ? '#E2725B' :
    $variant === 'recover' ? '#0F766E' :
    $variant === 'disabled' ? '#E4E7EC' :
    '#fff'
  )};

  color: ${({ $variant }) => (
    $variant === 'disabled' ? '#98A2B3' :
    $variant ? '#fff' : '#344054'
  )};

  box-shadow: ${({ $variant }) => ($variant ? '0 1px 2px rgba(16,24,40,0.06)' : 'inset 0 0 0 1px #D0D5DD')};
  &:disabled { cursor: not-allowed; }
`;

/* Loan & Contribution Details Styling */
const DetailsWrapper = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
`;

const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #101828;
`;

const DetailCard = styled.div`
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fafafa;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;

const DetailText = styled.p`
  margin: 4px 0;
  font-size: 14px;
  color: #444;
`;

const StatusText = styled(DetailText)`
  font-weight: bold;
  color: ${({ status }) =>
    status === 'active' ? 'green' :
    status === 'pending' ? 'orange' :
    status === 'default' ? 'red' :
    
      status === "written_off"      ? "gray"
      : "black"};
`;
